import {Component} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {CustomerService} from '../../../../services/customer.service';
import {MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import {BaseDialog} from '../../../../base-dialog';
import {PerfilService} from '../../../../services/ajs-perfil.service';
import {TextFormats} from '@mandae/ng-utils/mask';
import { AuthService } from '../../../../services/ajs-auth.service';
import { cpfCnpjMask } from '../../../../forms/cpf-cnpj.mask';
import {
  irParaConsoleDeConta,
  isKeycloakSession,
} from '../../../../../angularjs-app/services/auth/keycloak/keycloak.util';

@Component({
  selector: 'mandae-accept-return-dialog',
  templateUrl: 'accept-return-dialog.html',
  styleUrls: ['accept-return-dialog.scss']
})
export class AcceptReturnDialogComponent extends BaseDialog<AcceptReturnDialogComponent> {

  constructor(dialogRef: MatDialogRef<AcceptReturnDialogComponent>) {
    super(dialogRef);
  }
  confirm() {
    this.accept(true);
  }
}

@Component({
  selector: 'mandae-profile-setting-form',
  templateUrl: './profile-settings-form.component.html',
  styleUrls: ['./profile-settings-form.component.scss']
})
export class ProfileSettingsFormComponent {

  public profileForm: FormGroup;

  public loading: boolean;

  public prefixes = [];

  public readonly phoneMask = TextFormats.phoneMask;

  public readonly documentMask = cpfCnpjMask;

  // Senha e verificação em duas etapas ficam no Keycloak; a sessão do login legado não tem conta lá.
  public readonly keycloakSession = isKeycloakSession();

  constructor(private authService: AuthService,
              private customerService: CustomerService,
              private snackBar: MatSnackBar,
              private dialog: MatDialog,
              private profile: PerfilService) {

    this.loading = true;

    this.customerService.getPrefixes(authService.getCurrentUser().id).subscribe(prefixes => {
      this.prefixes = prefixes.prefixos;
    });

    this.customerService.getData().subscribe(
      customerData => {
        this.profileForm = new FormGroup({
          email: new FormControl(customerData.email, [ Validators.required ]),
          name: new FormControl(customerData.nome, [ Validators.required ]),
          phone: new FormControl(customerData.telefone.ddd + customerData.telefone.numero, [ Validators.required]),
          cnpj: new FormControl(customerData.cnpj, [ Validators.required ]),
          socialReason: new FormControl(customerData.razaoSocial, [ Validators.required ]),
          inscription: new FormControl(customerData.inscricaoEstadual),
          plan: new FormControl(customerData.plano, [ Validators.required ]),
          acceptReturn: new FormControl(customerData.aceitaDevolucao),
        }, {
          updateOn: 'change'
        });

        this.profileForm.controls['acceptReturn'].valueChanges.subscribe(value => this.acceptReturn(value));

        this.loading = false;
      }
    );
  }

  saveProfile() {
    if (this.profileForm.valid) {
      this.loading = true;
      const phone = this.profileForm.value.phone.replace(/\(|\)|\s|-/g, '');

      const data = {
        nome: this.profileForm.value.name,
        razaoSocial: this.profileForm.value.socialReason,
        inscricaoEstadual: this.profileForm.value.inscription,
        aceitaDevolucao: this.profileForm.value.acceptReturn,
        telefone: {
          id: null,
          numero: phone.substring(2, phone.length),
          ddd: phone.substring(0, 2)
        }};

      this.customerService.updateData(data).subscribe(() => {
        this.snackBar.open('Dados alterados com sucesso', 'Ok');
        this.loading = false;
      }, err => this.treatError(err));
    }
  }

  openAccountSecurity() {
    irParaConsoleDeConta();
  }

  private acceptReturn(value) {
    if (!value) {
      this.dialog.open(AcceptReturnDialogComponent, {
        closeOnNavigation: true,
        width: '600px',
        maxWidth: '95vw',
      }).afterClosed()
        .subscribe(result => {
          if (result) {
            this.saveAcceptReturn(false);
          } else {
            this.profileForm.controls['acceptReturn'].setValue(true, {emitEvent: false});
          }
        });
    } else {
      this.saveAcceptReturn(true);
    }
  }

  private saveAcceptReturn(value) {
    this.loading = true;

    this.customerService.updateAcceptReturn(this.profile.getCacheUserData().id, value)
      .subscribe(() => {
        this.snackBar.open('Opção de aceitar devolução foi atualizada com sucesso.', 'Ok');
        this.loading = false;
      }, err => this.treatError(err));
  }

  private treatError(err: any) {
    if (err.error && err.error.error) {
      this.snackBar.open(err.error.error.message, 'Fechar');
    } else {
      this.snackBar.open(err.message, 'Fechar');
    }
    this.loading = false;
  }
}
